import { SetupContext, Ref, unref } from 'vue-demi'
import { SmartblockEvent, AnalyticsEvent, ActionEvent, SmartblockCallEventMap, ActivationAnalyticsEvent, DisableActivationInstanceEvent } from '../types'
import { ExperienceActivationContext, ExperienceActivationInstance } from 'sd-types/app/experience/activation'

export function defineActivationListEmits () {
  return {
    openDetails: (_payload: {
      payload: SmartblockCallEventMap['openDetails']
      activation: ExperienceActivationInstance
      context: ExperienceActivationContext
    }) => true,
    action: (payload: ActionEvent) => payload != null,
    play: () => true,
    pause: () => true,
    close: () => true,
    analytics: (payload: ActivationAnalyticsEvent) => payload?.event != null,
    'disable-instance': (_payload: DisableActivationInstanceEvent) => true
  }
}

/**
 * Bubble up smartblock events to parents
 * @param context
 * @returns listeners
 */
export function useActivationListEvents (activation: Ref<ExperienceActivationInstance>, activationContext: Ref<ExperienceActivationContext>, context: SetupContext<ReturnType<typeof defineActivationListEmits>>) {
  // Just bypass events
  const onSmartblockEvent = (e: SmartblockEvent): void => {
    if (e.event === 'openDetails') {
      context.emit('openDetails', {
        payload: e.payload,
        activation: unref(activation),
        context: unref(activationContext)
      })
    } else if (e.event === 'disable-instance') {
      context.emit('disable-instance', {
        activation: unref(activation)
      })
    } else if (['play', 'pause'].includes(e.event)) {
      // @ts-expect-error FIXME not sure how to type this.
      context.emit(e.event)
    }
  }
  /**
   * Emit action and analytics
   * TODO: analytics reference point - change this when proper analytics functionality is supported
   */
  const onAnalytics = (e: AnalyticsEvent): void => { context.emit('analytics', { ...e, activation: unref(activation) }) }
  const onAction = (e: ActionEvent): void => { context.emit('analytics', { event: 'action', payload: { ...e }, activation: unref(activation) }) }
  return {
    onSmartblockEvent,
    onAnalytics,
    onAction
  }
}
export function useBypassActivationListEvents (context: SetupContext<ReturnType<typeof defineActivationListEmits>>) {
  return {
    openDetails: (payload: {
      payload: SmartblockCallEventMap['openDetails']
      activation: ExperienceActivationInstance
      context: ExperienceActivationContext
    }) => {
      context.emit('openDetails', payload)
    },
    play: () => context.emit('play'),
    pause: () => context.emit('pause'),
    action: (payload: ActionEvent) => context.emit('action', { ...payload }),
    analytics: (payload: ActivationAnalyticsEvent) => context.emit('analytics', { ...payload }),
    'disable-instance': (payload: DisableActivationInstanceEvent) => { context.emit('disable-instance', payload) }
  }
}
